"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAccountNumberAndCodeIfNeed = exports.formatBankAccount = exports.codeTypeName = exports.formatCzechAccountNumber = exports.formatAccountNumberWithPrefix = exports.formatAUCode = exports.formatPrefixNumber = exports.formatUnknownAccount = exports.formatIBAN = exports.matchAccountTypeToTransferRefundType = exports.setAccountNumberAndCodeByType = exports.detectAccountType = exports.detectCodeType = exports.isCzechBankCodeFormat = exports.isCzechAccountNumberFormat = exports.isIBANFormat = exports.startsWithLetter = void 0;
var chunk_1 = __importDefault(require("lodash/chunk"));
var types_1 = require("./types");
function startsWithLetter(accountNumberOrIban) {
    var regex = /^[A-Z]/;
    return regex.test(accountNumberOrIban);
}
exports.startsWithLetter = startsWithLetter;
function isIBANFormat(accountNumber) {
    return /^[A-Z][A-Z][0-9][0-9]([A-Z]|[0-9]){1,30}$/.test(accountNumber);
}
exports.isIBANFormat = isIBANFormat;
function isCzechAccountNumberFormat(accountNumber) {
    return /^((([0-9]{2,6}-){0,1}[0-9]{2,10})|([0-9]{2,16}))(\/[0-9]{4}){0,1}$/.test(accountNumber);
}
exports.isCzechAccountNumberFormat = isCzechAccountNumberFormat;
function isCzechBankCodeFormat(accountNumber) {
    return /^[0-9]{4}$/.test(accountNumber);
}
exports.isCzechBankCodeFormat = isCzechBankCodeFormat;
function detectCodeType(bankCode) {
    if (/^(([A-Z]|[0-9]){8}|([A-Z]|[0-9]){11})$/.test(bankCode)) {
        return types_1.BankCodeType.Bic;
    }
    else if (/^04[0-9]{7}$/.test(bankCode)) {
        return types_1.BankCodeType.Bik;
    }
    else if (/^0[0-9]{8}$/.test(bankCode)) {
        return types_1.BankCodeType.Cc;
    }
    else if (/^[0-9]{9}$/.test(bankCode)) {
        return types_1.BankCodeType.Fw;
    }
    else if (/^[0-9]{6}$/.test(bankCode)) {
        return types_1.BankCodeType.Au;
    }
    return undefined;
}
exports.detectCodeType = detectCodeType;
function detectAccountType(accountNumberWithPossibleCode) {
    if (isIBANFormat(accountNumberWithPossibleCode)) {
        return types_1.BankAccountFormatType.IBAN;
    }
    if (accountNumberWithPossibleCode.includes("/")) {
        var _a = accountNumberWithPossibleCode.split("/"), accountNumber = _a[0], bankCode = _a[1];
        if (isCzechAccountNumberFormat(accountNumber) && isCzechBankCodeFormat(bankCode)) {
            return types_1.BankAccountFormatType.CZECH;
        }
    }
    if (isCzechAccountNumberFormat(accountNumberWithPossibleCode)) {
        return types_1.BankAccountFormatType.CZECH;
    }
    else {
        return types_1.BankAccountFormatType.OTHER;
    }
}
exports.detectAccountType = detectAccountType;
function setAccountNumberAndCodeByType(accountNumberWithPossibleCode, accountType, account) {
    if (accountType === types_1.BankAccountFormatType.CZECH && accountNumberWithPossibleCode.includes("/")) {
        var _a = accountNumberWithPossibleCode.split("/"), accountNumber = _a[0], bankCode = _a[1];
        account.accountNumber = accountNumber;
        account.bank = bankCode;
    }
    else {
        account.accountNumber = accountNumberWithPossibleCode;
    }
}
exports.setAccountNumberAndCodeByType = setAccountNumberAndCodeByType;
function matchAccountTypeToTransferRefundType(accountType) {
    switch (accountType) {
        case types_1.BankAccountFormatType.IBAN:
            return types_1.TransferRefundType.SEPA;
        case types_1.BankAccountFormatType.CZECH:
            return types_1.TransferRefundType.DOMESTIC;
        case types_1.BankAccountFormatType.OTHER:
        default:
            return types_1.TransferRefundType.FOREIGN;
    }
}
exports.matchAccountTypeToTransferRefundType = matchAccountTypeToTransferRefundType;
function formatIBAN(iban, nbsp) {
    if (nbsp === void 0) { nbsp = false; }
    if (iban) {
        var chunks = chunk_1.default(iban.split(""), 4);
        return chunks.map(function (chunk) { return chunk.join(""); }).join(nbsp ? " " : " ");
    }
    return "";
}
exports.formatIBAN = formatIBAN;
function formatUnknownAccount(account) {
    var formattedString = "";
    if (account === null || account === void 0 ? void 0 : account.accountNumber) {
        formattedString = account.accountNumber;
    }
    if (account === null || account === void 0 ? void 0 : account.bank) {
        if (formattedString) {
            formattedString += " ";
        }
        formattedString += "K\u00F3d: " + account.bank;
    }
    return formattedString;
}
exports.formatUnknownAccount = formatUnknownAccount;
function formatAUCode(code) {
    if (code) {
        var chunks = chunk_1.default(code.split(""), 3);
        return chunks.map(function (chunk) { return chunk.join(""); }).join("-");
    }
}
exports.formatAUCode = formatAUCode;
function formatPrefixNumber(prefixNumber) {
    var numericValue = parseInt(prefixNumber);
    if (numericValue) {
        return numericValue.toString();
    }
    return undefined;
}
exports.formatPrefixNumber = formatPrefixNumber;
function formatAccountNumberWithPrefix(accountNumber, prefixNumber) {
    var formattedAccount = "";
    var formattedPrefix = prefixNumber ? formatPrefixNumber(prefixNumber) : undefined;
    if (formattedPrefix) {
        formattedAccount = formattedPrefix + "-";
    }
    formattedAccount += accountNumber;
    return formattedAccount;
}
exports.formatAccountNumberWithPrefix = formatAccountNumberWithPrefix;
function formatCzechAccountNumber(account) {
    var _a;
    var formattedAccount = "";
    if (!account || !account.accountNumber) {
        return formattedAccount;
    }
    var number = account.accountNumber;
    var length = number.length;
    var accountNumber;
    var prefix;
    if (length > 10 && !number.includes("-")) {
        prefix = number.slice(0, number.length - 10);
        accountNumber = number.slice(number.length - 10, length);
    }
    else if (number.includes("-")) {
        _a = number.split("-"), prefix = _a[0], accountNumber = _a[1];
    }
    else {
        accountNumber = number;
    }
    formattedAccount = formatAccountNumberWithPrefix(accountNumber, prefix);
    if (account.bank) {
        formattedAccount += "/" + account.bank;
    }
    else if (account.bankCode) {
        formattedAccount += "/" + account.bankCode;
    }
    return formattedAccount;
}
exports.formatCzechAccountNumber = formatCzechAccountNumber;
function codeTypeName(bankCode) {
    var codeType;
    if (bankCode) {
        codeType = detectCodeType(bankCode);
    }
    return codeType || "Code";
}
exports.codeTypeName = codeTypeName;
function formatBankAccount(account) {
    var accountToFormat = account;
    var formattedAccount = "";
    if (!accountToFormat || !accountToFormat.accountNumber) {
        return formattedAccount;
    }
    if (accountToFormat.accountNumber.includes("/")) {
        var parsedAccountParts = accountToFormat.accountNumber.split("/");
        if (parsedAccountParts.length === 2) {
            accountToFormat.accountNumber = parsedAccountParts[0];
            accountToFormat.bank = parsedAccountParts[1];
        }
    }
    if (isIBANFormat(accountToFormat.accountNumber)) {
        formattedAccount = "IBAN:\u00A0" + formatIBAN(accountToFormat.accountNumber, true);
        if (accountToFormat.bank) {
            formattedAccount += "\r\n " + codeTypeName(accountToFormat.bank) + ":\u00A0" + accountToFormat.bank;
        }
    }
    else if (isCzechAccountNumberFormat(accountToFormat.accountNumber)) {
        formattedAccount = formatCzechAccountNumber(accountToFormat);
    }
    else {
        formattedAccount = formatUnknownAccount(accountToFormat);
    }
    return formattedAccount;
}
exports.formatBankAccount = formatBankAccount;
function resetAccountNumberAndCodeIfNeed(counterpartyBank, transferType, codeType) {
    if (!counterpartyBank.accountNumber)
        return;
    var accountNumber = counterpartyBank.accountNumber;
    var accountNumberNotCorrespondingToType = (transferType === types_1.TransferRefundType.DOMESTIC && !/^[0-9]/.test(accountNumber)) ||
        (transferType === types_1.TransferRefundType.SEPA && !/^([A-Z]|[a-z])/.test(accountNumber));
    if (accountNumberNotCorrespondingToType) {
        counterpartyBank.accountNumber = "";
        counterpartyBank.bankCode = "";
    }
}
exports.resetAccountNumberAndCodeIfNeed = resetAccountNumberAndCodeIfNeed;
